import { apiAuth, apiResponseType } from ".";

/**
 * Tela de acesso como usuário (personificação).
 *
 * O backend protege a listagem e o início do acesso com o middleware
 * "panel.permission:impersonate-users": Super Admin alcança todos os tenants e
 * o admin de tenant apenas o próprio.
 */
export type ImpersonationUserRow = {
  id: number;
  uuid: string;
  name: string;
  email: string;
  document: string | null;
  phone: string | null;
  photo: string | null;
  is_active: number | boolean;
  user_type_id: number;
  tenant_id: number | null;
  can_be_impersonated: boolean;
  user_type: { id: number; name: string } | null;
  tenant: { id: number; name: string } | null;
  roles: { id: number; name: string }[];
};

export type ImpersonationFilters = {
  search?: string;
  user_type_id?: number | string;
  tenant_id?: number | string;
  is_active?: boolean | string;
  role?: string;
  unity_id?: number | string;
  per_page?: number;
};

export const getUsersForImpersonation = (
  page: number = 1,
  filters: ImpersonationFilters = {}
) =>
  apiAuth.get("users/all", {
    params: {
      page,
      ...filters,
    },
  }) as apiResponseType;

export const impersonateUser = (uuid: string) =>
  apiAuth.post(`users/${uuid}/impersonate`) as apiResponseType;

export const stopImpersonation = () =>
  apiAuth.post("impersonate/stop") as apiResponseType;
